import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
// import Link from '@material-ui/core/Link';
// import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
// import DownloadIcon from '../../assets/DownloadIcon';
import SubpageTitle from '../../components/SubpageTitle';
import TabletExitButton from '../../components/TabletExitButton';
import PhotoGroupCover from './PhotoGroupCover';
import PhotoGroupContent from './PhotoGroupContent';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 785,
    maxWidth: '100%',
  },
  sectionTitle: {
    fontWeight: 'bold',
    fontSize: 15,
  },
  awardTextContainer: {
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(-2),
      textAlign: 'center',
    },
    marginTop: theme.spacing(-4),
    marginBottom: theme.spacing(8),
    fontWeight: 400,
    color: '#000000',
  },
  awardMainText: {
    fontWeight: 700,
    color: '#000000',

  },
  awardSecondText: {
    color: '#000000',
  },
  supportText: {
    fontFamily: 'Fancy Cut Pro',
    color: theme.palette.secondary.main,
    fontStyle: 'italic',
    fontSize: 18,
  },
  // spanText: {
  //   fontFamily: 'Avenir Next',
  //   fontWeight: 'normal',
  //   fontStyle: 'normal',
  //   fontSize: 15,
  //   border: '1px solid black',
  //   padding: '2px 5px',
  //   marginRight: '5px',
  // },
  // place: {
  //   fontSize: 18,
  //   fontFamily: 'Baskerville Old',
  //   fontStyle: 'italic',
  // },
  singleImage: {
    position: 'relative',
    width: '100%',
    marginTop: '2rem',
    paddingBottom: '2rem',
    '&:hover $downloadButton': {
      opacity: 1,
    },
  },
  previewImage: {
    width: '100%',
  },
  downloadButton: {
    position: 'absolute',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    boxShadow: '0 4px 4px rgba(0, 0, 0, 0.4)',
    top: theme.spacing(-4),
    right: theme.spacing(-4),
    zIndex: 1,
    opacity: 0,
    transition: 'opacity 0.5s, background-color 0.5s',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  explainer: {
    color: theme.palette.secondary.main,
    fontSize: 18,
    fontFamily: 'Baskerville Old',
    fontStyle: 'italic',
    margin: theme.spacing(3, 0, 1),
  },
  grid: {
    marginTop: 30,
    paddingBottom: theme.spacing(6),
  },
  mailto: {
    color: 'inherit',
  },
}));

// const myPicUrl = 'https://www.getpica.com/checkins/3OW408F2N';
// const imageUrl = 'https://cdn.eventtia.com/event_files/192416/large/wm24grouppicture17199332511719933251.jpg?1719933251';
// const toDownloadImageUrl = 'https://cdn.eventtia.com/event_files/192416/original/wm24grouppicture17199332511719933251.jpg?1719933251';
const Gallery = () => {
  const classes = useStyles();

  const [currentPhotoGroup, setCurrentPhotoGroup] = useState();
  const closeGroup = () => {
    setCurrentPhotoGroup();
  };

  // const downloadImage = (url, filename) => {
  //   fetch(url)
  //     .then((response) => response.blob())
  //     .then((blob) => {
  //       const objectUrl = window.URL.createObjectURL(blob);
  //       const link = document.createElement('a');
  //       link.href = objectUrl;
  //       link.setAttribute('download', filename);
  //       document.body.appendChild(link);
  //       link.click();
  //       link.parentNode.removeChild(link);
  //     });
  // };

  return (
    <div className={classes.root}>
      <TabletExitButton />
      {!currentPhotoGroup && (
        <>
          <SubpageTitle text="Photo gallery" />
          <div className={classes.awardTextContainer}>
            <Typography className={classes.awardMainText}>WORLD MEETING 202.26</Typography>
            <Typography className={classes.awardSecondText}>Sardinia, Italy</Typography>
          </div>
          <div>
            <Typography className={classes.supportText}>
              This event will be photographed and recorded. Images will be available from July 7.
            </Typography>
          </div>
          {/* <div className={classes.singleImage}>
            <IconButton
              className={classes.downloadButton}
              onClick={() => downloadImage(toDownloadImageUrl, 'group_picture.jpg')}
              color="primary"
            >
              <DownloadIcon />
            </IconButton>
            <img className={classes.previewImage} src={imageUrl} alt="Group" />
          </div> */}
          <Grid container spacing={1} className={classes.grid}>
            <Grid item xs={12}>
              <PhotoGroupCover
                group="aw"
                mainText="AWARDS WEEK"
                height={241}
                // setCurrentPhotoGroup={setCurrentPhotoGroup}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PhotoGroupCover
                group="jun08"
                topText="Mon"
                mainText="08"
                bottomText="June"
                height={189}
                setCurrentPhotoGroup={setCurrentPhotoGroup}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PhotoGroupCover
                group="jun09"
                topText="Tue"
                mainText="09"
                bottomText="June"
                height={189}
                setCurrentPhotoGroup={setCurrentPhotoGroup}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PhotoGroupCover
                group="jun10"
                topText="Wed"
                mainText="10"
                bottomText="June"
                height={189}
                setCurrentPhotoGroup={setCurrentPhotoGroup}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PhotoGroupCover
                group="jun11"
                topText="Thu"
                mainText="11"
                bottomText="June"
                height={189}
                setCurrentPhotoGroup={setCurrentPhotoGroup}
              />
            </Grid>
            {/* <Grid item xs={4}>
              <PhotoGroupCover
                group="may24"
                topText="Sat"
                mainText="24"
                bottomText="May"
                height={290}
                setCurrentPhotoGroup={setCurrentPhotoGroup}
              />
            </Grid> */}
          </Grid>
        </>
      )}
      {!!currentPhotoGroup && (
        <PhotoGroupContent
          group={currentPhotoGroup}
          closeGroup={closeGroup}
        />
      )}
    </div>
  );
};

Gallery.propTypes = {
};

Gallery.defaultProps = {
};

export default Gallery;
